<template>
    <SidebarPanel
        :is-open="ui.notebook.opened"
        :title="localizations[lang].notebook"
        side="left"
        persistent
        mobile-fullscreen
        resizable
        @close="onClose"
    >
        <template #toolbar>
            <Tabs />
        </template>

        <ReaderNoteAndHighlight
            v-show="showHighlightsAndNotes"
            id="notebook-tabpanel-all"
            role="tabpanel"
            aria-labelledby="notebook-tab-all"
        />
        <ReaderHighlights
            v-show="ui.features.highlights.opened"
            id="notebook-tabpanel-highlights"
            role="tabpanel"
            aria-labelledby="notebook-tab-highlights"
        />
        <ReaderNotes
            v-show="ui.features.notes.opened"
            id="notebook-tabpanel-notes"
            role="tabpanel"
            aria-labelledby="notebook-tab-notes"
        />
        <ReaderBookmarks
            v-show="ui.features.bookmarks.opened"
            id="notebook-tabpanel-bookmarks"
            role="tabpanel"
            aria-labelledby="notebook-tab-bookmarks"
        />
        <QuickHighlightSection />
    </SidebarPanel>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Tabs from './partials/Tabs.vue';
import ReaderNotes from './Tabs/ReaderNotes.vue';
import ReaderHighlights from './Tabs/ReaderHightlights.vue';
import ReaderNoteAndHighlight from './Tabs/ReaderNoteAndHighlight.vue';
import ReaderBookmarks from './Tabs/ReaderBookmarks.vue';
import SidebarPanel from '../Components/SidebarPanel.vue';
import QuickHighlightSection from './partials/QuickHighlightSection.vue';

export default {
    components: {
        Tabs,
        ReaderNotes,
        ReaderHighlights,
        ReaderNoteAndHighlight,
        ReaderBookmarks,
        SidebarPanel,
        QuickHighlightSection,
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        ...mapGetters(['showHighlightsAndNotes']),
    },
    methods: {
        ...mapActions(['toggleNotebook']),
        ...mapMutations(['closeNoteEditor']),
        // The close button, Escape and back all land here. A note being written sits one
        // level in, like the flashcard form, so it returns to the list before the notebook
        // closes, dropping what it holds as Cancel does.
        onClose() {
            if (this.ui.noteEditor.opened) this.closeNoteEditor();
            else this.toggleNotebook();
        },
    },
};
</script>
